import React, { useContext, useState } from "react";
import "./DocumentSplit.css";
import { DocumentSplitForm, DocumentSplitTable } from "./Components";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { FormatDate, GenerateRandomId, IsValidDate, SortData } from "commonFunctions/commonFunctions";

const DocumentSplit = (props) => {
    const { 
        data = {}, 
        setDocumentData, 
        docSplit, 
        setDocSplitData, 
        getDocumentDetailData, 
        getSplitProgressPercentage,
        classificationMappingData,
        setDataSave,
        updateDocumentData,
        setLoader, 
        isDarkMode
    } = useContext(DocumentDetailContext);
    const [splitFormDetails, setSplitFormDetails] = useState({
        patient_name: data.Entity_Details.extraction?.patientName?.value || "",
        dob: data.Entity_Details.extraction?.dateOfBirth?.value || "",
    });
    const [isEdit, setSplitEdit] = useState(false);
    const [docSplitError, setDocSplitError] = useState(null)

    const navigateToChildDocument = async (docId) => {
        setLoader(prevState => ({
            ...prevState,
            fullLoader: true,
            miniLoader: true
        }));
        let childData = await getDocumentDetailData(docId);
        updateDocumentData({...childData});
        setDocSplitData(prevState => ({
            ...prevState,
            docSplitData: []
        }));
        
    }

    const handleSplitAction = (editData, action) => {
        let tempData = JSON.parse(JSON.stringify(docSplit.docSplitData || []));
        if (action == "edit") {
            let obj = {};
            tempData.forEach(m => {
                if (m.id == editData.id) {
                    obj = Object.assign(m, editData);
                }
            });
            setSplitFormDetails(obj);
            setSplitEdit(true);
        } else if (action == "delete") {
            tempData = tempData.filter(m => m.id != editData.id);
            let sortedData = SortData(tempData, "end", "asc");
            let res = { ...data };
            res.Entity_Details.docSplitData = [...sortedData];
            updateDocumentData(res);
            setDocSplitData(prevState => ({
                ...prevState,
                docSplitData: [...sortedData]
            }));
            setDataSave(true);
        }
    }

    const handleSplitFormChange = (col, val) => {
        setDocSplitError("");
        setSplitFormDetails(prevState => ({
            ...prevState,
            [col]: (col == "start" || col == "end") && val != "" ? Number(val) : val
        }))
    }

    const addSplitData = (formData, action) => {
        let tempData = JSON.parse(JSON.stringify(docSplit.docSplitData || []));
        let { dob, start, end, patient_name, sub_category, id, category } = formData, error = '';
        setDocSplitError("");

        start = Number(start);
        end = Number(end);

        let pageRanges = [];
        for (let i = start; i <= end; i++) {
            pageRanges.push(i);
        }

        let checkPageNumbers = tempData.some(m => {
            let tmpStart = Number(m.start), tmpEnd = Number(m.end);
            if (id == m.id) return false;
            else if (pageRanges.includes(tmpStart) || pageRanges.includes(tmpEnd)) return true;
            return false;
        })

        if (!dob || !start || !end || !patient_name || !sub_category) error = "Please enter all the fields";
        else if (dob != "No DOB in Document" && !IsValidDate(dob)) error = "Please enter valid date of birth";
        else if (start > end || checkPageNumbers) error = "Please enter valid page range";
        else if (start > data.Page_Count || end > data.Page_Count) error = "Page number exceeds limit"
        else if (!category) error = "Please select valid sub category"

        if (error) {
            setDocSplitError(error);
            return 0;
        };

        formData.dob = dob == "No DOB in Document" ? dob : FormatDate({ date: dob, format: "MM/DD/YYYY" });
        formData.patient_name = formData.patient_name?.trim() || "";
        if (action == "add") tempData.push({ ...formData, id: GenerateRandomId() });
        if (action == "update") tempData.forEach(m => {
            if (m.id == formData.id) m = Object.assign(m, formData);
        });

        tempData.forEach(m => {
            m.doc_level = classificationMappingData[m.sub_category]?.doc_level?.display_name;
        });

        let sortedData = SortData(tempData, "end", "asc");
        let temp = { ...data };
        temp.Entity_Details.docSplitData = [...sortedData];
        updateDocumentData(temp);
        setDocSplitData(prevState => ({
            ...prevState,
            docSplitData: [...sortedData]
        }));
        delete formData.start;
        setSplitFormDetails({...formData, end: ""});
        setSplitEdit(false);
        setDataSave(true);
    }
    return <div>
        {!(data?.Entity_Details?.enable_doc_split == false) && <DocumentSplitForm
            splitDetails={splitFormDetails}
            splitData={docSplit.docSplitData}
            onChange={handleSplitFormChange}
            addSplitData={addSplitData}
            getSplitProgressPercentage={getSplitProgressPercentage}
            error={docSplitError}
            isEdit={isEdit}
            data={data}
            classificationMappingData={classificationMappingData}
            splitProgressPercentage={docSplit.splitProgressPercentage}
            isDarkMode={isDarkMode}
        />}
       {Boolean(docSplit?.docSplitData?.length) && <DocumentSplitTable data={docSplit.docSplitData || []} documentData={data} onClick={handleSplitAction} navigateToChildDocument={navigateToChildDocument} />}
    </div>
}

export default DocumentSplit;